// @view/authentication/EmailValidationBodyError.view.tsx

import React from "react";
import * as styles from "@styles/EmailValidation.css";
import { Button } from "@components/ui/button";
import * as Option from "@utils/Option";
import { ok } from "@ps-bridge/ok";
import * as IO from "@ps-bridge/interop/io";
import type { EmailValidationViewProps } from "@ps-bridge/contracts/emailValidation";

type EmailValidationBodyErrorViewProps = Pick<
  EmailValidationViewProps,
  "errorMessage" | "onNavigateToLogin"
>;

const defaultErrorMessage = "We could not verify this link.";

const EmailValidationBodyErrorView: React.FC<EmailValidationBodyErrorViewProps> = ({
  errorMessage,
  onNavigateToLogin,
}) => {
  return (
    <>
      <p className={styles.errorText} data-testid="email-verify-error-message">
        {errorMessage === "" ? defaultErrorMessage : errorMessage}
      </p>
      <div className={styles.actions}>
        <Button
          variant="ghost"
          data-testid="email-verify-back-to-login"
          onClick={() => IO.run(onNavigateToLogin(ok))}
          asChild={Option.none()}
        >
          Back to login
        </Button>
      </div>
    </>
  );
};

export default EmailValidationBodyErrorView;
